module.exports = __webpack_public_path__ + "static/rime_s_binding_ice-379a0d40e94110fca867c4df47140837.png";